<template>
    <kgr-generic-select
        :options="filteredOptions"
        :value="value"
        :disabled="disabled"
        @post-input="updateGender($event)"
    />
</template>

<script>
import GenericSelect from './GenericSelect.vue'

export default {
    components: {
        'kgr-generic-select': GenericSelect
    },
    props: {
        value: {
            type: String,
            required: false,
            default: ''
        },
        asInput: {
            type: Boolean,
            required: false,
        },
        excluded: {
            type: Array,
            required: false,
            default() {
                return [];
            },
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data() {
        return {
            options: [
                'gender.f',
                'gender.m',
                'gender.v',
                'gender.u',
            ],
        }
    },
    computed: {
        filteredOptions() {
            let options = Array.from(this.options);
            this.excluded.forEach(element => {
                options = options.filter(el => el !== element);
            });
            return options;
        },
    },
    methods: {
        updateGender(value) {
            const selection = '' === value ? null : value
            this.$emit('input', selection);
            this.$nextTick(() => {
                this.$emit('post-input', selection);
            });
        },
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>

